// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"ArticleAddFunctionsButton_ProseMirror__2zNCA","articleAddFunctionsButton":"ArticleAddFunctionsButton_articleAddFunctionsButton__1Gkhs"};